import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AcknowledgeFormModule } from '../acknowledge-form/acknowledge-form.module';
import { DonateNowModule } from '../donate-now/donate-now.module';
import { FrCardModule } from '../fr-card/fr-card.module';
import { PlaceholderLoaderModule } from '../placeholder-loader/placeholder-loader.module';
import { DonationMethodsComponent } from './components/donation-methods/donation-methods.component';
import { InViewportModule } from 'ng-in-viewport';
import { InputModule } from '../input/input.module';
import { IntlInputModule } from '../intl-input/intl-input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { UpiIconsComponent } from './components/upi-icons/upi-icons.component';
import { SharedModule } from '../../shared/shared.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FrCardModule,
    DonateNowModule,
    PlaceholderLoaderModule,
    AcknowledgeFormModule,
    InViewportModule,
    InputModule,
    IntlInputModule,
    ReactiveFormsModule,
    ModuleLoaderModule,
    MatCardModule,
    MatIconModule
  ],
  declarations: [DonationMethodsComponent , UpiIconsComponent],
  exports: [DonationMethodsComponent]
})
export class DonationMethodsModule { }
